module.exports = __webpack_public_path__ + "img/logo2.bfe5ead5.png";